import { useMemo } from 'react'

import { NotificationVerb } from 'src/shared/schemas/notifications'

type LynkWorkflowTitleProps = {
  notificationVerb: NotificationVerb | null
  consumerFirstName?: string
}

const LynkWorkflowTitle = ({ notificationVerb, consumerFirstName }: LynkWorkflowTitleProps) => {
  const text = useMemo(() => {
    if (!notificationVerb) {
      return 'New information regarding Lynk'
    }
    if (notificationVerb === NotificationVerb.TWILIO_BRAND_FAILED) {
      return 'Your brand registration needs attention.'
    } else if (notificationVerb === NotificationVerb.TWILIO_CAMPAIGN_FAILED) {
      return "Your campaign was not approved. We're working on a fix."
    } else if (notificationVerb === NotificationVerb.TWILIO_NUMBER_SELECTION) {
      return 'Your registration is complete!'
    } else if (notificationVerb === NotificationVerb.LYNK_COMPLETED) {
      return `I completed the workflow for ${consumerFirstName}. See results and next steps.`
    } else if (notificationVerb === NotificationVerb.LYNK_NEED_ASSISTANCE) {
      return `I need your input for ${consumerFirstName}'s conversation.`
    } else if (notificationVerb === NotificationVerb.LYNK_HOSTILE) {
      return `I need you to take over with ${consumerFirstName}. They seem frustrated.`
    } else if (notificationVerb === NotificationVerb.LYNK_EXTREME_CASE) {
      return `Urgent: ${consumerFirstName} needs immediate attention. Review now.`
    } else if (notificationVerb === NotificationVerb.LYNK_OFF_TOPIC) {
      return `${consumerFirstName} keeps going off-topic. I've tried redirecting multiple times.`
    } else if (notificationVerb === NotificationVerb.LYNK_DISABLED) {
      return `${consumerFirstName} opted out of automated messages.`
    } else if (notificationVerb === NotificationVerb.LYNK_FAILED) {
      return `I encountered an issue with ${consumerFirstName}. Please take over.`
    }
    return null
  }, [notificationVerb, consumerFirstName])

  return <p className="text-[13px] font-medium leading-[18px] text-primary">{text}</p>
}

export default LynkWorkflowTitle
